export interface ThemeScheme {
    readonly name: string;
    readonly value: "light" | "dark" | "system";
}

export const THEME_SCHEMES: ThemeScheme[] = [
    { name: "Light", value: "light" },
    { name: "Dark", value: "dark" },
    { name: "System", value: "system" },
];
